import React from 'react';

type OverlayProps = {
  isOpen: boolean;
  onClose: () => void;
  zIndex?: number;
};

/**
 * Versão simples do Overlay — apenas uma div cobrindo a tela com sombreamento leve.
 * Uso:
 * <Overlay isOpen={active} onClose={handleClose} zIndex={1} />
 */
export default function Overlay({ isOpen, onClose, zIndex = 1 }: OverlayProps) {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      role="presentation"
      aria-hidden={!isOpen}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.12)',
        zIndex,
      }}
      data-testid="simple-overlay"
    />
  );
}
